import { render, staticRenderFns } from "./Part5.vue?vue&type=template&id=12a4e174&scoped=true"
import script from "./Part5.vue?vue&type=script&lang=js"
export * from "./Part5.vue?vue&type=script&lang=js"
import style0 from "./Part5.vue?vue&type=style&index=0&id=12a4e174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a4e174",
  null
  
)

export default component.exports